import { getRelatedFiles, getRelatedEmails } from 'owa-meeting-insights';
import { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';

export default function areInsightsAvailable(
    meetingId: string,
    dataFetchSource: InsightsDataFetchSource
): boolean {
    const files = getRelatedFiles(meetingId, dataFetchSource);
    const emails = getRelatedEmails(meetingId, dataFetchSource);

    return files.length + emails.length > 0;
}
